import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { QuizFacade } from '../facades/quizes.facade';

export function quizCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const quizFacade = inject(QuizFacade);
        quizFacade.clear();

        return true;
    };
}
